import { Image } from '@tiptap/extension-image';

export const ImageExtended = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: 'width: 100%; height: auto; cursor: pointer;',
        parseHTML: (element) => {
          const width = element.getAttribute('width');
          return width
            ? `width: ${width}px; height: auto; cursor: pointer;`
            : `${element.style.cssText}`;
        },
      },
      title: {
        default: '',
        parseHTML: (element) => element.getAttribute('title') || '',
      },
    };
  },
  addNodeView() {
    return ({ node, editor, getPos }) => {
      const {
        view,
        options: { editable },
      } = editor;
      const { style } = node.attrs;
      const $wrapper = document.createElement('figure');
      const $container = document.createElement('div');
      const $img = document.createElement('img');
      const $caption = document.createElement('figcaption');

      const iconStyle = 'width: 24px; height: 24px; cursor: pointer;';

      const dispatchNodeView = () => {
        if (typeof getPos === 'function') {
          const pos = getPos();
          if (pos === undefined) return;
          const newAttrs = {
            ...node.attrs,
            style: `${$img.style.cssText}`,
          };
          view.dispatch(view.state.tr.setNodeMarkup(pos, null, newAttrs));
        }
      };

      $wrapper.appendChild($container);
      $wrapper.appendChild($caption);
      $wrapper.style.width = "fit-content"
      const marginMatch = style.match(/margin:\s*([^;]+)/);
      if (marginMatch) {
        $wrapper.style.margin = marginMatch[1]
      }
      $caption.textContent = node.attrs.title || '';
      $caption.style.marginTop = '8px';
      $container.setAttribute('style', `${style}`);
      $container.setAttribute('id', `image-container`);
      $container.appendChild($img);

      Object.entries(node.attrs).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        $img.setAttribute(key, value);
      });

      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'title') {
            const title = $img.getAttribute('title') || '';
            $caption.textContent = title
            if (["placeholder", ""].includes(title)) {
              $caption.style.opacity = 0
            } else {
              $caption.style.opacity = 1
            }
          }
        });
      });

      observer.observe($img, {
        attributes: true
      });

      let isActive = false;

      if (!editable) return { dom: $container };

      const dotPosition = '-6px';
      const dotsPosition = [
        `top: ${dotPosition}; left: ${dotPosition}; cursor: nwse-resize;`,
        `top: ${dotPosition}; right: ${dotPosition}; cursor: nesw-resize;`,
        `bottom: ${dotPosition}; left: ${dotPosition}; cursor: nesw-resize;`,
        `bottom: ${dotPosition}; right: ${dotPosition}; cursor: nwse-resize;`,
      ];

      let isResizing = false;
      let startX: number, startWidth: number;

      $caption.addEventListener("click", (e) => {
        editor.setEditable(false);
        $caption.setAttribute("contenteditable", true)
        $caption.focus()
      })

      $caption.addEventListener("blur", (e) => {
        const captionText = e.currentTarget.textContent
        $img.setAttribute("title", captionText)
        editor.setEditable(true)
        const pos = getPos();
        if (pos === undefined) return;
        const newAttrs = {
          ...node.attrs,
          title: captionText,
        };
        view.dispatch(view.state.tr.setNodeMarkup(pos, null, newAttrs));
      })

      const leftButton = document.querySelector('button[data-alignement="left"]')
      const centerButton = document.querySelector('button[data-alignement="center"]')
      const rightButton = document.querySelector('button[data-alignement="right"]')

      const handlePositionClick = async (figure, img, position) => {
        figure.style.display = await "block"
        figure.style.margin = await position
        img.style.margin = await position
        dispatchNodeView();
      };

      const handleLeftClick = () => handlePositionClick($wrapper, $img, "0 auto 0 0");
      const handleCenterClick = () => handlePositionClick($wrapper, $img, "0 auto");
      const handleRightClick = () => handlePositionClick($wrapper, $img, "0 0 0 auto");

      $container.addEventListener('click', (e) => {

        leftButton.addEventListener("click", handleLeftClick)
        centerButton.addEventListener("click", handleCenterClick)
        rightButton.addEventListener("click", handleRightClick)

        if (isActive) return;
        isActive = true;

        $container.setAttribute(
          'style',
          `position: relative; border: 1px solid #6DE19E; ${style} cursor: pointer;`
        );

        const existingImageMenu = document.getElementById("image-menu")
        const template = document.getElementById("image-modification-template");
        const clone = template.content.cloneNode(true);
        const isCaptionAllowed = clone.getElementById("image-menu").dataset.captionAllowed === "true"

        if (!existingImageMenu && isCaptionAllowed) {

          $container.appendChild(clone);

          const removeImageButton = document.getElementById("image-menu-remove");
          const addCaptionToImageButton = document.getElementById("image-menu-add-caption");
          const removeCaptionToImageButton = document.getElementById("image-menu-remove-caption");

          if ($img.getAttribute('title') === "") {
            addCaptionToImageButton.classList.remove("hidden")
            removeCaptionToImageButton.classList.add("hidden")
          } else {
            removeCaptionToImageButton.classList.remove("hidden")
            addCaptionToImageButton.classList.add("hidden")
          }

          removeImageButton.addEventListener("click", () => {
            const pos = getPos();
            if (pos === undefined) return;
            view.dispatch(view.state.tr.delete(pos, pos + 1));
            $wrapper.remove();
          });

          addCaptionToImageButton.addEventListener("click", () => {
            editor.setEditable(false);
            $caption.setAttribute("contenteditable", true)
            $caption.textContent = "Rédigez votre légende"
            const range = document.createRange();
            range.selectNodeContents($caption);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
          });

          removeCaptionToImageButton.addEventListener("click", (e) => {
            $img.setAttribute("title", '')
            const newAttrs = {
              ...node.attrs,
              title: '',
            };
            const pos = getPos();
            if (pos !== undefined) {
              view.dispatch(view.state.tr.setNodeMarkup(pos, null, newAttrs));
            }
          });
        }

        dotsPosition.forEach((position, index) => {
          const $dot = document.createElement('div');
        $dot.setAttribute(
          'style',
          `width: 12px; height: 12px; border: 1.5px solid #6DE19E; border-radius: 2px; ${dotsPosition[index]}; background-color: #E7F8EE`
        );
        $dot.classList.add("absolute");

        $dot.addEventListener('mousedown', (e) => {
          e.preventDefault();
          isResizing = true;
          startX = e.clientX;
          startWidth = $container.offsetWidth;

          const onMouseMove = (e: MouseEvent) => {
            if (!isResizing) return;
            const deltaX = index % 2 === 0 ? -(e.clientX - startX) : e.clientX - startX;

            const newWidth = startWidth + deltaX;
            const minWidth = isCaptionAllowed ? 265 : 50

            if (newWidth > minWidth && newWidth < 750) {
              $container.style.width = newWidth + 'px';
              $img.style.width = newWidth + 'px';
            }
          };

          const onMouseUp = () => {
            if (isResizing) {
              isResizing = false;
            }
            dispatchNodeView();
            isActive = false;

            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);

            leftButton.removeEventListener('click', handleLeftClick)
            centerButton.removeEventListener('click', handleCenterClick)
            rightButton.removeEventListener('click', handleRightClick)
          };

          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);
        });

          $container.appendChild($dot);
        });
      });

      document.addEventListener('click', (e: MouseEvent) => {
        const $target = e.target as HTMLElement;

        const isClickInside = $container.contains($target) || $target.style.cssText === iconStyle;

        if (!isClickInside) {
          $container.style.border = "none";
          const dots = $container.querySelectorAll(".absolute");
          dots.forEach((dot) => {
            dot.remove();
          });
          isActive = false;

          leftButton.removeEventListener('click', handleLeftClick)
          centerButton.removeEventListener('click', handleCenterClick)
          rightButton.removeEventListener('click', handleRightClick)
        }
      });

      return {
        dom: $wrapper,
      };
    };
},
});

export default ImageExtended;
